import { render, staticRenderFns } from "./WhyHelpFind.vue?vue&type=template&id=27b80798&"
import script from "./WhyHelpFind.vue?vue&type=script&lang=js&"
export * from "./WhyHelpFind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports